import { FC } from 'react';
import {
  ThresholdResult,
  WbTag,
  WbTruncatedTypographyWrapper,
} from '@agilelab/plugin-wb-platform';
import { Box, createStyles, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { GovernanceEntitiesQueryType } from '../../../../graphql/governanceEntities';
import { Task } from '../../types';

interface Props {
  metric: GovernanceEntitiesQueryType['cgp_governance_entity'][0];
  task: Task;
}

const useStyles = makeStyles(() =>
  createStyles({
    detailName: {
      flex: 1,
    },
    chip: {
      margin: 0,
    },
  }),
);

export const MetricItem: FC<Props> = ({ metric, task }) => {
  const classes = useStyles();
  return (
    <>
      <Box display="flex" justifyContent="space-between">
        <ThresholdResult
          value={task.metricSpecificResult?.value || 0}
          result={task.metricSpecificResult?.threshold}
          hasError={task.errors && task.errors.length > 0}
        />
        <WbTag
          tag={{
            tagFQN: 'Metric',
          }}
        />
      </Box>
      <div className={clsx(classes.detailName)}>
        <WbTruncatedTypographyWrapper
          style={{
            fontWeight: 700,
          }}
          value={metric.name}
        />
        <WbTruncatedTypographyWrapper value={metric.description ?? ''} />
      </div>
    </>
  );
};
